import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { createOrder } from '../../Redux/features/order/orderSlice';
import axios from 'axios';
import { API_URL, config } from '../../config/config';
import { getCartData } from '../../Redux/features/auth/authSlice';

const OrderDetail = () => {
	const navigate = useNavigate();

	const [customer, setCustomer] = useState(true);
	const dispatch = useDispatch();
	const [ProductData, setProductData] = useState([]);
	const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
	const [hasFetched, setHasFetched] = useState(false);

	useEffect(() => {
		const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
		if (cartData.length === 0 || hasFetched) return;

		setProductData(cartData);
		setHasFetched(true);
	}, [hasFetched]);

	const [customerDetails, setCustomerDetails] = useState({
		Id: '',
		MobileNo: '',
		Name: '',
		GSTNo: '',
		UserAddress: '',
		Remark: '',
	});

	const [UserDetails, setUserDetails] = useState({
		Name: '',
		FirmName: '',
		MobileNo: '',
		GSTNo: '',
		Email: '',
		UserAddress: '',
	});
	const [error, setError] = useState('');

	// Function to call and get users data by mobile no
	const handleChange = async (e) => {
		setErrorMessage('');
		const MobileNo = e.target.value;
		setCustomerDetails((prevDetails) => ({ ...prevDetails, MobileNo }));

		// If MobileNo has 10 digits, fetch the user details
		if (MobileNo.length === 10) {
			try {
				const response = await axios.post(
					`${API_URL}/user/fetchuserbymobileno`,
					{ MobileNo },
					config
				);

				if (response.data.success === true) {
					setCustomerDetails({
						...response.data.User,
						Remark: customerDetails.Remark,
					});
				} else if (response.data.success === false) {
					setErrorMessage(response.data.message);
				}
			} catch (error) {
				toast.error('Failed to fetch user details');
			}
		} else {
			setCustomerDetails({
				MobileNo: MobileNo,
				Name: '',
				GSTNo: '',
				UserAddress: '',
				Remark: '',
			});
		}
	};

	// Input fields for the form
	const inputFields = [
		{
			id: 1,
			name: 'MobileNo',
			label: 'Mobile No ',
			placeHolder: 'Users Mobile No',
			value: customerDetails.MobileNo,
			type: 'number',
		},
		{
			id: 2,
			name: 'Name',
			label: 'Name ',
			placeHolder: 'Customers Name',
			value: customerDetails.Name,
			type: 'text',
		},
		{
			id: 3,
			name: 'GSTNo',
			label: 'GST No',
			placeHolder: 'Customers GST No',
			value: customerDetails.GSTNo,
			type: 'number',
		},
		{
			id: 4,
			name: 'UserAddress',
			label: 'Customers Address',
			placeHolder: 'Customers Address',
			value: customerDetails.UserAddress,
			type: 'text',
		},
		{
			id: 5,
			name: 'Remark',
			label: 'Order Note',
			placeHolder: 'Remark',
			value: customerDetails.Remark,
			type: 'message',
			rows: 3,
			cols: 4,
			isTextarea: true, // Indicates this should render as a textarea
		},
	];

	// Input fields for the form
	const UserInputFields = [
		{
			id: 1,
			name: 'Name',
			label: 'Name',
			placeHolder: 'Users Name',
			value: UserDetails.Name,
			type: 'text',
		},
		{
			id: 2,
			name: 'FirmName',
			label: 'Firm Name ',
			placeHolder: 'User Firm Name',
			value: UserDetails.FirmName,
			type: 'text',
		},
		{
			id: 3,
			name: 'MobileNo',
			label: 'Mobile No',
			placeHolder: 'User Mobile No',
			value: UserDetails.MobileNo,
			type: 'text',
		},
		{
			id: 4,
			name: 'GSTNo',
			label: 'GST No',
			placeHolder: 'Customers GST No',
			value: UserDetails.GSTNo,
			type: 'text',
		},
		{
			id: 5,
			name: 'Email',
			label: 'Email',
			placeHolder: 'User Email',
			value: UserDetails.Email,
			type: 'text',
		},
		{
			id: 6,
			name: 'UserAddress',
			label: 'Customers Address',
			placeHolder: 'Customers Address',
			value: UserDetails.UserAddress,
			type: 'text',
		},
	];

	const [errorMessage, setErrorMessage] = useState('');

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setCustomerDetails((prevDetails) => ({
			...prevDetails,
			[name]: value,
		}));
	};

	const handleChangeUser = (e) => {
		const { name, value } = e.target;

		// Validation for Name and FirmName fields
		if (name === 'Name' || name === 'FirmName') {
			const regex = /^[a-zA-Z\s]*$/;
			if (!regex.test(value)) {
				return; // Prevent invalid input
			}
		}

		// Validation for MobileNo and GSTNo fields
		if (name === 'MobileNo' || name === 'GSTNo') {
			const regex = /^[0-9]*$/; // Only numbers allowed
			if (!regex.test(value)) {
				return; // Prevent invalid input
			}
		}

		// Update state with valid input
		setUserDetails((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		if (
			!UserDetails.Name ||
			!UserDetails.FirmName ||
			!UserDetails.MobileNo ||
			!UserDetails.GSTNo ||
			!UserDetails.Email ||
			!UserDetails.UserAddress
		) {
			return toast.error('Please fill in all fields.');
		}

		const data = {
			Name: UserDetails.Name,
			MobileNo: UserDetails.MobileNo,
			FirmName: UserDetails.FirmName,
			GSTNo: UserDetails.GSTNo,
			UserEmail: UserDetails.Email,
			UserAddress: UserDetails.UserAddress,
		};

		try {
			const response = await axios.post(`${API_URL}/Admin/AddUser`, data, config);

			if (response.data.success === true) {
				toast.success(response.data.message);
				setUserDetails({
					Name: '',
					MobileNo: '',
					FirmName: '',
					GSTNo: '',
					Email: '',
					UserAddress: '',
				});
			}
		} catch (error) {
			setError(error.response.data.message);
		}
	};

	const handlePlaceOrder = (e) => {
		e.preventDefault();

		// Check if all required fields are filled
		if (
			!customerDetails.MobileNo ||
			!customerDetails.Name ||
			!customerDetails.GSTNo ||
			!customerDetails.UserAddress ||
			!customerDetails.Remark
		) {
			setErrorMessage('Please fill in all the required fields.');
			return;
		}

		setErrorMessage(' ');
		const OrderDate = new Date(Date.now());
		// const TotalQty = ProductData.length;
		const TotalQty = ProductData.reduce(
			(sum, product) => sum + product.OrderDetails.reduce((qtySum, order) => qtySum + order.Qty, 0),
			0
		);
		const OrderDetails = {
			AccountId: customerDetails.Id,
			OrderDate,
			TotalQuantity: TotalQty,
			TotalAmount: overallTotal,
			Name: customerDetails.Name,
			MobileNo: customerDetails.MobileNo,
			Remark: customerDetails.Remark,
			BillInfoDetails: {
				BillDetails: ProductData.flatMap((product) =>
					product.OrderDetails.map((order) => ({
						ImagePathId: order.ImagePathId,
						ArticleCode: product.ArticleCode,
						ProductName: product.ProductName,
						ProductId: product.ProductId,
						CategoryId: product.CategoryId,
						Category: product.Category,
						SubCategoryId: product.SubCategoryId,
						SubCategory: product.SubCategory,
						Color: order.color,
						ColorId: order.ColorId || order.colorId,
						Size: order.size,
						SizeId: order.SizeId || order.sizeId,
						Discount: order.Discount || 0,
						DiscountMRP: order.DiscountMRP,
						MRP: order.price || 0,
						NoofSet: order.NoofSet || 1,
						TotalQty: order.Qty || 1,
					}))
				),
			},
		};

		dispatch(createOrder(OrderDetails))
			.then((response) => {
				if (response.payload.success === true) {
					// Navigation to Confirmation page once response is OK
					navigate('/confirmation', {
						state: {
							MobileNo: customerDetails.MobileNo,
							Name: customerDetails.Name,
							UserAddress: customerDetails.UserAddress,
							subtotal,
							ProductData,
							OrderDate: new Date().toLocaleString(),
							orderID: response.payload.orderId,
						},
					});

					//remove the cartData from localStorage
					localStorage.removeItem('CartData');
					dispatch(getCartData());
				} else {
					setErrorMessage(response.payload);
				}
			})
			.catch((error) => {
				setErrorMessage('Something Went Wrong!');
			});
	};

	const subtotal = ProductData.reduce((acc, product) => {
		return acc + product.DiscountMRP * product.Qty;
	}, 0).toFixed(2);

	const overallTotal = ProductData.reduce((total, product) => {
		const totalPrice =
			product.OrderDetails?.reduce((sum, item) => sum + (item.Qty * item.DiscountMRP || 0), 0) || 0;

		return total + totalPrice;
	}, 0);

	return (
		<div className='flex flex-col lg:flex-row items-start justify-center md:pt-24 pt-10 lg:gap-32 gap-6 md:px-36 px-6'>
			{/* Customer detail form */}
			<div className='w-full lg:w-1/3'>
				<p className='font-semibold text-2xl mb-1'>Fill Customer Detail</p>
				{errorMessage && <p className='text-red-600'>{errorMessage}</p>}
				<div className='w-[55px] border-[1px] border-black mb-8' />
				<div className='flex flex-col lg:flex-row gap-7 mb-5'>
					<div>
						<label className=' cursor-pointer'>
							<input
								type='radio'
								id='customer'
								checked={customer}
								name='customer'
								onChange={() => setCustomer(true)}
								className='mr-4'
							/>
							Select Existing Name
						</label>
					</div>
					<div>
						<label className='  cursor-pointer'>
							<input
								type='radio'
								checked={!customer}
								name='customer'
								onChange={() => setCustomer(false)}
								className='mr-4'
							/>
							Add A New Customer
						</label>
					</div>
				</div>

				{/* Existing customer */}
				{customer && (
					<form onSubmit={handlePlaceOrder}>
						{inputFields.map((fields) => (
							<div key={fields.id}>
								<label className='text-sm'>{fields.label}</label>
								{fields.name === 'Remark' ? (
									<textarea
										name={fields.name}
										placeholder={fields.placeHolder}
										value={customerDetails[fields.name]}
										rows={fields.rows}
										cols={fields.cols}
										onChange={handleInputChange}
										className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-1 md:mb-4 mb-2 md:p-3 p-2 focus:outline-1 focus:shadow-outline border-[0.25px] border-black border-opacity-30'
									/>
								) : (
									<input
										type={fields.type}
										name={fields.name}
										placeholder={fields.placeHolder}
										value={customerDetails[fields.name]}
										onChange={fields.name === 'MobileNo' ? handleChange : handleInputChange}
										className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-1 md:mb-4 mb-2 md:p-3 p-2 focus:outline-1 focus:shadow-outline border-[0.25px] border-black border-opacity-30'
										readOnly={fields.name !== 'MobileNo' && fields.name !== 'Remark'}
									/>
								)}
							</div>
						))}

						<button type='submit' className='proBtn w-full rounded-none text-lg md:py-3 py-2 mt-2'>
							Place Order
						</button>
					</form>
				)}

				{/* New Customer */}
				{!customer && (
					<div>
						<form onSubmit={handleSubmit}>
							<div>
								{UserInputFields.map((fields) => (
									<div key={fields.id}>
										<label className='text-sm'>{fields.label}</label>
										<input
											type={fields.type}
											name={fields.name}
											placeholder={fields.placeHolder}
											value={UserDetails[fields.name]}
											onChange={handleChangeUser}
											className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-1 md:mb-4 mb-2 md:p-3 p-2 focus:outline-1 focus:shadow-outline border-[0.25px] border-black border-opacity-30'
										/>
									</div>
								))}
								<p className=' text-red-600 '>{error}</p>
								<button
									type='submit'
									className='proBtn w-full rounded-none text-lg md:py-3 py-2 mt-2'>
									Submit
								</button>
							</div>
						</form>
					</div>
				)}
			</div>

			{/* Product checkout */}
			<div className='pt-1 w-full lg:w-1/2 mb-10'>
				<p className='font-semibold text-2xl mb-1'>Order Detail</p>
				<div className='w-[55px] border-[1px] border-black mb-8' />

				<div className='overflow-x-auto custom-scrollbar '>
					<table className='min-w-full mb-10 text-left'>
						<thead>
							<tr className=''>
								<th className='px-4 py-2 text-lg font-medium'>Product</th>
								<th className='px-4 py-2 text-lg font-medium text-center'>Quantity</th>
								<th className='px-4 py-2 text-lg font-medium text-end pr-10'>Total</th>
							</tr>
						</thead>
						<tbody className='text-sm'>
							{ProductData.map((product, index) => {
								// Calculate total quantity and total price per product
								const totalQty = product.OrderDetails.reduce((sum, order) => sum + order.Qty, 0);
								const totalPrice =
									product.OrderDetails?.reduce(
										(sum, item) => sum + item.Qty * item.DiscountMRP,
										0
									) || 0;

								return (
									<React.Fragment key={index}>
										{/* Product Name Row */}
										<tr className='   bg-gray-100'>
											<td className='px-4 py-2 font-medium border-t border-black' colSpan={3}>
												{product.ProductName?.length > 30
													? product.ProductName.slice(0, 30) + '...'
													: product?.ProductName}
											</td>
										</tr>

										{/* Order Details */}
										{product.OrderDetails.map((order, orderIndex) => (
											<tr key={`${index}-${orderIndex}`} className=' text-xs'>
												<td className='px-4 py-2'>
													(Color: {order.color}) (Size: {order.size || 'N/A'}) (Price:
													<span className='font-sans text-sm'> ₹</span>
													{order.DiscountMRP.toLocaleString('en-IN', {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													})}
													)
												</td>
												<td className='px-4 py-2 text-center'>{order.Qty}</td>
												<td className='px-4 py-2 text-end pr-10'>
													<span className='font-sans text-sm'> ₹</span>
													{(order.DiscountMRP * order.Qty).toLocaleString('en-IN', {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													})}
												</td>
											</tr>
										))}

										{/* Product-wise Total Row */}
										<tr className='border-b font-medium bg-gray-200 '>
											<td className='px-4 py-1 text-right'>Total:</td>
											<td className='px-4 py-1 text-center'>{totalQty}</td>
											<td className='px-4 py-1 text-end pr-10'>
												<span className='font-sans text-base'> ₹ </span>
												{totalPrice.toLocaleString('en-IN', {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												})}
											</td>
										</tr>
									</React.Fragment>
								);
							})}

							{/* Grand Total Row */}
							<tr className='border-t-2 border-black font-medium'>
								<td className='px-4 py-2 text-right'>Grand Total:</td>
								<td className='px-4 py-2 text-center'>
									{ProductData.reduce(
										(sum, product) =>
											sum + product.OrderDetails.reduce((qtySum, order) => qtySum + order.Qty, 0),
										0
									)}
								</td>
								<td className='px-4 py-2 text-end pr-10'>
									Subtotal: <span className='font-sans text-base'>₹ </span>
									{overallTotal.toLocaleString('en-IN', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default OrderDetail;
